import { Tooltip } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import React from 'react'
import { VscFilePdf } from 'react-icons/vsc'
import { ButtonHeaderModule } from 'styled/Buttons.styled'
import { IconGeneric } from 'styled/Icons.styled'

export const ExportButton = ({ document, fileName = '' }) => {
  return (
    <Tooltip placement='top' hasArrow label='Exportar PDF'>
      <PDFDownloadLink document={document} fileName={fileName}>
        <ButtonHeaderModule bgColor='#03C39A' className='ms-1'>
          <IconGeneric width='16px' className=' text-white' as={VscFilePdf} />
        </ButtonHeaderModule>
      </PDFDownloadLink>
    </Tooltip>
  )
}
